
<br><br><br>
    <div class="page-wrapper bg-gra-03 p-t-45 p-b-50">
        <div  class="wrapper wrapper--w790">
            <div class="card card-5">
                <div class="card-heading">
                    <h2 *ngIf="ville != 'إختار المعتمدية'"class="title">{{ville}}</h2>
                    <h2 *ngIf="ville == 'إختار المعتمدية'"class="title">{{region}}</h2>

                </div>
                
                <div class="card-body"  *ngIf="data">
                    <div class="container" *ngIf="data.docs.length>0">
                        <div class="row">
                            <div class="col-md-3"></div>
                    <table class="table">
                        <thead class="">
                          <tr>
                         
                            <th scope="col">Capacité</th>
<!--                             <th scope="col">Quantité</th>
 -->                            <th scope="col">Modele</th>
                            <th scope="col">Prix/nuit</th>
                            <th scope="col">Tel</th>
                            <th scope="col" *ngIf="ville=='إختار المعتمدية'">Ville</th>
                            <th scope="col"></th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr  *ngFor="let d of data.docs; let i = index" >
                            <td *ngIf="d">{{d.capacite}} litres</td>
<!--                             <td *ngIf="d.length>0">{{d..quantite}} concentrateurs</td>
 -->                            <td *ngIf="d">{{d.modele}} </td>
                            <td *ngIf="d">{{d.prix}}<span *ngIf="d.prix"> dt</span> </td>
                            <td *ngIf="d">{{d.tel}} </td>
                            <td *ngIf="d && ville=='إختار المعتمدية'">{{d.ville}} </td>

                            <td *ngIf="d"><button  matTooltip="Rapporter"  mat-raised-button (click)="openDialog(d._id)" ><i  class="fas fa-flag"></i> </button></td>

                            
                          </tr>
                          
                        </tbody>
                        
                      </table>
                   <div  style="text-align: center;">
                    <mat-paginator [length]="totalRecords"
                    [pageSize]="itemPerPage"
                    [pageSizeOptions]="[5,10, 25, 100]"
                    (page)="handlePageEvent($event)"
                    >
                       </mat-paginator>                  </div>
                    </div>
                    </div>
               <div style="text-align: center;" *ngIf="data.docs.length==0">
                <h1>  للأسف ما فماش في البلاصة هذي <br> شوف حسب الولاية الكل وتنجم تزيد ماكينة أكسيجين <br><a href="ajouter">من هنا</a> </h1>

               </div>
                </div>
                
            </div>
           <br>
           <div style="text-align: center;">
            <a routerLink="/chercher" class="btn btn--radius-2 btn--red" type="submit">لوج في بلاصة أخرى</a>
        </div>
        </div>
    </div>
